import DialogCancelWlistConfirm from './DialogCancelWlistConfirm'

export default DialogCancelWlistConfirm